// src/services/dashboard.js
import { get, post } from './httpSevice'

// 统一响应数据处理
const handleResponse = (response) => {
    if (response.code === 200) {
        return response.data
    } else {
        throw new Error(response.message || '请求失败')
    }
}

export const dashboardAPI = {
    // 订单统计数据
    getOrderStatistics: () =>
        get('/agent/shop_evaluation_order/orderStatistics')
            .then(handleResponse),

    // 最新数据
    getLatestData: (params) =>
        post('/agent/shop_evaluation_order/orderNewStatistics', params)
            .then(handleResponse),

    // 员工数据
    getStaffData: (params) =>
        post('/agent/shop_evaluation_order/adminOrderStatistics', params)
            .then(handleResponse),

    // 订单来源数据
    getSourceData: (params) =>
        post('/agent/shop_evaluation_order/totalOrderStatistics', params)
            .then(handleResponse),

    // 生成订单统计
    getCreateData: (params) =>
        post('/agent/shop_evaluation_order/createOrderStatistics', params)
            .then(handleResponse),

    // 预约订单统计
    getAppointmentData: (params) =>
        post('/agent/shop_evaluation_order/appointmentOrderStatistics', params)
            .then(handleResponse),

    // 完成订单统计
    getCompleteData: (params) =>
        post('/agent/shop_evaluation_order/completeOrderStatistics', params)
            .then(handleResponse),

    // 店铺数据统计
    getShopData: (params) =>
        post('/agent/shop_evaluation_order/shopStatistics', params)
            .then(handleResponse),

    // 省市区数据
    getAreaList: (params) =>
        post('/agent/shop_evaluation_order/getAreaList', params)
            .then(handleResponse),
}